var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import App from './main';
import CategoryCard from './components/CategoryCard';
import RecipeCard from './components/RecipeCard';
import Recipe from './components/Recipe';
import BtnMore from './components/BtnMore';
import toChangeBackground from './utilities/toChangeBackground';
import variables from './utilities/_variables';
const { base_url } = variables;
const UIController = new class UIController {
    renderCategoryItems() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const parent = document.querySelector('#nav_options');
                const raw = yield fetch(`${base_url}/categories.php`);
                const { categories } = yield raw.json();
                for (const category of categories) {
                    const { strCategory, idCategory } = category;
                    const li = yield new CategoryCard(strCategory, idCategory).render();
                    parent.appendChild(li);
                }
            }
            catch (error) {
                alert('Error in Rendering NavItems');
                console.log('Error in Rendering NavItems', error);
            }
        });
    }
    renderRecipeCards() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const more = document.querySelector('#btn_more');
                const parent = document.querySelector('#list_recipecards');
                const datas = new Array();
                for (let count = 1; count <= 9; count++) {
                    const raw = yield fetch(`${base_url}/random.php`);
                    const { meals } = yield raw.json();
                    datas.push(meals[0]);
                }
                parent.innerHTML = ``;
                for (const meal of datas) {
                    const { idMeal, strMeal, strCategory, strMealThumb, strSource, strArea } = meal;
                    const li = yield new RecipeCard(idMeal, strMeal, strMealThumb, strArea, strCategory, strSource).render();
                    parent.appendChild(li);
                    const image = document.getElementById(`image_${idMeal}`);
                    image.style.backgroundImage = `url(${strMealThumb})`;
                }
                if (!more)
                    new BtnMore('/random.php').render();
            }
            catch (error) {
                alert('Error in Rendering RecipeCards');
                console.log('Error in Rendering RecipeCards', error);
            }
        });
    }
    renderRecipeCardsByCat(query) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const more = document.querySelector('#btn_more');
                const parent = document.querySelector('#list_recipecards');
                const raw = yield fetch(`${base_url}/filter.php?c=${query}`);
                const { meals } = yield raw.json();
                parent.innerHTML = ``;
                for (const meal of meals) {
                    const { idMeal, strMeal, strMealThumb, strSource, strArea } = meal;
                    const li = yield new RecipeCard(idMeal, strMeal, strMealThumb, strArea, query, strSource).render();
                    parent.appendChild(li);
                    const image = document.getElementById(`image_${idMeal}`);
                    image.style.backgroundImage = `url(${strMealThumb})`;
                }
                if (!more)
                    new BtnMore(query).render();
            }
            catch (error) {
                alert('Error in Rendering RecipeCards by Category');
                console.log('Error in Rendering RecipeCards by Category', error);
            }
        });
    }
    renderRecipe(query) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const raw = yield fetch(`${base_url}/lookup.php?i=${query}`);
                const { meals } = yield raw.json();
                App.onchangeBackground();
                App.router('recipe');
                yield toChangeBackground(App.getState().background);
                new Recipe(meals[0]).render();
            }
            catch (error) {
                alert('Error in Rendering Recipe');
                console.log('Error in Rendering Recipe', error);
            }
        });
    }
};
export default UIController;
